/**
 * 权限指令 - 直接从缓存获取权限信息
 * 用于按钮级别的权限控制
 */

/**
 * 从 localStorage 获取缓存的权限
 */
const getPermissionsFromCache = () => {
  try {
    const cached = localStorage.getItem('userPermissions');
    return cached || [];
  } catch (error) {
    console.error('Failed to parse cached permissions:', error);
    return [];
  }
};

/**
 * 检查是否有指定权限
 * @param {string} permission - 权限代码
 * @returns {boolean}
 */
const hasPermission = (permission) => {
  const permissions = getPermissionsFromCache();
//   console.log('Permissions:', permissions);
//   console.log('Checking permission:', permission , permissions.includes(permission) );
  return permissions.includes(permission);
};

/**
 * 检查是否有任一权限
 * @param {string[]} permissionList - 权限代码数组
 * @returns {boolean}
 */
const hasAnyPermission = (permissionList) => {
  return permissionList.some(permission => hasPermission(permission));
//   return permissionList.some(permission => permissions.includes(permission));
};

/**
 * 检查是否有所有权限
 * @param {string[]} permissionList - 权限代码数组
 * @returns {boolean}
 */
const hasAllPermissions = (permissionList) => {
  return permissionList.every(permission => hasPermission(permission));
};

/**
 * 权限指令
 * 使用方式:
 * v-permission="'user:create'" - 单个权限
 * v-permission="['user:create', 'user:edit']" - 任一权限
 * v-permission.all="['user:create', 'user:edit']" - 所有权限
 */
export const permission = {
  mounted(el, binding) {
    const { value, modifiers } = binding;

    if (!value) {
      console.warn('v-permission directive requires a value');
      return;
    }

    let hasAuth = false;

    if (Array.isArray(value)) {
      // 数组形式
      if (modifiers.all) {
        // 需要所有权限
        hasAuth = hasAllPermissions(value);
      } else {
        // 默认：有任一权限即可
        hasAuth = hasAnyPermission(value);
      }
    } else if (typeof value === 'string') {
      // 字符串形式，检查单个权限
      hasAuth = hasPermission(value);
    } else {
      console.warn('v-permission directive value must be string or array');
    }

    if (!hasAuth) {
      // 没有权限则移除该元素
      el.parentNode && el.parentNode.removeChild(el);
    }
  },
};

export default permission;
